'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Root, Trigger, Portal, Overlay, Content, Title } from '../../node_modules/@radix-ui/react-dialog/dist/index.js';
import { Root as Root$1 } from '../../node_modules/@radix-ui/react-visually-hidden/dist/index.js';
import classnames from '../../node_modules/classnames/index.js';
import { useState, useEffect, Children, isValidElement } from 'react';
import modules_ef226cb7 from './Modal.module.scss.js';
import { Header } from './components/Header/Header.js';
import { Body } from './components/Body/Body.js';
import { Footer } from './components/Footer/Footer.js';
import { useConstellationProviderRef } from '../ConstellationProvider/ConstellationProvider.hooks.js';
import { CustomHeader } from './components/CustomHeader/CustomHeader.js';
import { CloseButton } from './components/CloseButton/CloseButton.js';
import { CustomFooter } from './components/CustomFooter/CustomFooter.js';

const Modal = ({ children, className, "data-testid": testId, drawer, fullHeightOnMobile, overlay = true, onClose, open, size = "m", title, trigger, transition = drawer ? "slideIn" : "fadeIn", ...rest }) => {
    const { constellationProviderRef } = useConstellationProviderRef();
    const [constellationProviderElement, setConstellationProviderElement] = useState(null);
    useEffect(() => {
        if (constellationProviderRef && constellationProviderRef.current) {
            setConstellationProviderElement(constellationProviderRef.current);
        }
    }, [constellationProviderRef]);
    // Conditionally add the container prop to the portal
    const portalContainerProp = constellationProviderElement
        ? { container: constellationProviderElement }
        : {};
    /**
     * Radix 'Dialog' requires the presence of a 'DialogTitle' component. The 'Header'
     * and 'CustomHeader' components both use the 'DialogTitle' component internally,
     * so no error is raised. But when building the 'Modal' from scratch, an error
     * will be raised, and therefore we need to output an empty 'DialogTitle' component.
     */
    const hasTitle = Children.toArray(children).some((child) => isValidElement(child) &&
        (child.type === Header || child.type === CustomHeader));
    return (jsxs(Root, { open: open, onOpenChange: onClose, children: [trigger && jsx(Trigger, { asChild: true, children: trigger }), jsxs(Portal, { ...portalContainerProp, children: [overlay && (jsx(Overlay, { className: classnames(modules_ef226cb7.overlay, modules_ef226cb7[`transition-${size}`], modules_ef226cb7[`transition-${transition}`], modules_ef226cb7[`transition-${drawer ? "drawer" : "modal"}`]) })), jsxs(Content
                    /**
                     * Radix themselves suggest setting 'aria-describedby' to undefined if no 'Description' element is used.
                     * https://www.radix-ui.com/primitives/docs/components/dialog#description
                     */
                    // eslint-disable-next-line no-undefined
                    , { "aria-describedby": undefined, className: classnames(modules_ef226cb7[size], {
                            [modules_ef226cb7.modal]: !drawer,
                            [modules_ef226cb7.drawer]: drawer,
                            [modules_ef226cb7.full]: fullHeightOnMobile,
                        }, modules_ef226cb7[`transition-${size}`], modules_ef226cb7[`transition-${transition}`], modules_ef226cb7[`transition-${drawer ? "drawer" : "modal"}`], className), "data-testid": testId, ...rest, children: [!hasTitle && (jsx(Root$1, { children: jsx(Title, { "aria-hidden": "true", asChild: true, children: jsx("span", { children: title }) }) })), children] })] })] }));
};
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
Modal.CloseButton = CloseButton;
Modal.CustomHeader = CustomHeader;
Modal.CustomFooter = CustomFooter;

export { Modal };
//# sourceMappingURL=Modal.js.map
